import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { commonErr } from "../../../common/errors";
import { CarTransmission, CarFuel } from "../../../common/common";

import { MessageBox } from "../../../common/messagebox";

import ImageLightBox from "../../../common/imagelightbox";

import {
	IcShareLink,
	SeatCar,
	FuelCar,
	FuelCCar,
	TransCar,
	IcPhotos
} from "../../../common/svg";


import cover_default from "../../../../static/images/cover_default.png";

const CSDetailCover = ({ info, vehicleName }) => {
	const [covers, setCovers] = useState([]);
	const [lightBox, setLightBox] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);

	const { photos, name } = info;
	const [copied, setCopied] = useState(false);

	

	useEffect(() => {
		if (photos) {
			if (covers.length < 4 && photos.length < 4) {
				setCovers([...photos, photos[0]]);
			} else {
				setCovers(photos);
			}
		} else {
			setCovers([cover_default]);
		}
	}, []);

	const showLightBox = (i) => {
		setLightBox(true);
		setPhotoIndex(i);
	};

	const hideLightBox = () => {
		setLightBox(false);
	};

	const toggleCopyBox = () => {
		setCopied(!copied);
	};

	return (

		<div className="cover-car"> 
        <div className="cover-header"> 
          <h3>{info.name}</h3>
          <div className="wrap-svg shared"> 
              <CopyToClipboard text={window.location.href} onCopy={toggleCopyBox}>
                  <div className="wrap-svg wrap-ic share">
                      <IcShareLink />
                  </div>
              </CopyToClipboard>
          </div>
        </div>
		<div className="car-img" >
			<img loading="lazy" src={covers && covers[0]} />
			<div className="img-details">
				<span className="content-tag df-align-center">Ảnh đại diện
					<span className="tooltip icon--m"> 
						<span className="wrap-svg">
							<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M9.08984 9.00008C9.32495 8.33175 9.789 7.76819 10.3998 7.40921C11.0106 7.05024 11.7287 6.91902 12.427 7.03879C13.1253 7.15857 13.7587 7.52161 14.2149 8.06361C14.6712 8.60561 14.9209 9.2916 14.9198 10.0001C14.9198 12.0001 11.9198 13.0001 11.9198 13.0001" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 17H12.01" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</span>
						<span className="tooltip-text">Trong trường hợp nhiều xe có sẵn, ưu tiên chọn lựa của khách hàng</span></span></span>

				<div className="see-more-img" onClick={() => showLightBox(0)}> 
					<div className="wrap-svg"> 
						<IcPhotos />
					</div>
				<p>Xem tất cả ảnh</p>
		
  		</div>
	</div>

		</div>
        <div className="outstanding-features"> 
          <div className="outstanding-features__item"> 
		  		<div className="wrap-svg">
					<SeatCar />
				</div>
            <div className="title"> 
              <p className="sub">Loại xe</p>
              <p className="main">{vehicleName}</p>
            </div>
          </div>
		  <div className="outstanding-features__item">
					<div className="wrap-svg">
						<TransCar />
					</div>
					<div className="title">
						<p className="sub">Truyền động</p>
						<p className="main">{CarTransmission[info.transmission]}</p>
					</div>
				</div>
				<div className="outstanding-features__item">
					<div className="wrap-svg">
						<FuelCar />
					</div>
					<div className="title">
						<p className="sub">Nhiên liệu</p>
						<p className="main">{CarFuel[info.fuel]}</p>
					</div>
				</div>
				{info.optionsFuelConsumption > 0 && (
					<div className="outstanding-features__item">
						<div className="wrap-svg">
							<FuelCCar />
						</div>
						<div className="title">
							<p className="sub">NL tiêu hao</p>
							<p className="main">
								{info.optionsFuelConsumption} {info.optionsFuel == 3 ? "km /lần sạc" : "lít/100km"}
							</p>
						</div>
					</div>
				)}
        </div>
			<MessageBox error={commonErr.SUCCESS} show={copied} hideModal={toggleCopyBox} message="Đã sao chép liên kết" />
			{lightBox && (
				<ImageLightBox isOpen={lightBox} photoIndex={photoIndex} images={covers} hideLightBox={hideLightBox} />
			)}

			{/* <div className="m-container">
				<div className="cover-car-container">
					<div className="main-img">
						<div className="cover-car-item" onClick={() => showLightBox(0)}>
							<img loading="lazy" src={covers && covers[0]} />
						</div>
					</div>
					<div className="sub-img">
						{covers.flatMap((cover, i) =>
							i > 0 && i < 4 ? (
								<div key={i} className="cover-car-item" onClick={() => showLightBox(i)}>
									<img loading="lazy" src={cover} />
								</div>
							) : (
								[]
							)
						)}
					</div>
					<div className="see-more-img" onClick={() => showLightBox(0)}>
						<div className="wrap-svg">
							<IcPhotos />
						</div>
						<p>Xem tất cả ảnh</p>
					</div>
				</div> */}
			{/* </div> */}
			
			{/* <Swiper
				className="cover-car-swiper swiper-cover-car"
				slidesPerView={1}
				modules={[Pagination]}
				pagination={{
					el: ".pagi-cover",
					clickable: true,
					dynamicBullets: true,
				}}>
				{covers?.map((cover, i) => (
					<SwiperSlide key={i}>
						<div className="fix-img">
							<img loading="lazy" src={cover} />
						</div>
					</SwiperSlide>
				))}
				<div className="swiper-pagination pagi-cover"></div>
			</Swiper>
			{lightBox && (
				<ImageLightBox isOpen={lightBox} photoIndex={photoIndex} images={covers} hideLightBox={hideLightBox} />
			)} */}
		</div>
	);
};

export default CSDetailCover;
